import { render } from "./SeatDetails.vue?vue&type=template&id=04423e7c&scoped=true"
import script from "./SeatDetails.vue?vue&type=script&lang=js"
export * from "./SeatDetails.vue?vue&type=script&lang=js"

import "./SeatDetails.vue?vue&type=style&index=0&id=04423e7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04423e7c"]])

export default __exports__